import { BasicLabel, BasicSelect, BasicTextField, SingleDatepicker } from 'components';
import { ISettingList, ReqCreateSignUp } from 'domains/Pkg';
import { Row, Column } from 'styles';

interface Props {
  createSignUpRequest: ReqCreateSignUp;
  setCreateSignUpRequest: React.Dispatch<React.SetStateAction<ReqCreateSignUp>>;
  settings?: ISettingList;
}

export const SignUpFirstStep: React.FC<Props> = ({
  createSignUpRequest,
  setCreateSignUpRequest,
  settings
}) => {
  if (!settings) {
    return null;
  }

  return (
    <Column>
      <Row>
        <Column fullWidth gap="9px">
          <BasicLabel label={'Project'} />
          <BasicTextField placeholder="Fadhili Gas Increment Project" disabled />
        </Column>

        <Column fullWidth gap="9px">
          <BasicLabel label={'Company'} />
          <BasicSelect
            placeholder="Select Company"
            value={createSignUpRequest.companyId}
            options={settings.companyList.map((company) => ({
              label: company.name,
              value: company.id
            }))}
            onChange={(e) => {
              setCreateSignUpRequest((prev) => ({
                ...prev,
                companyId: e.target.value as string
              }));
            }}
          />
        </Column>
      </Row>

      <Row>
        <Column fullWidth gap="9px">
          <BasicLabel label={'Name (English)'} required />
          <Row>
            <BasicTextField
              fullWidth
              placeholder="SUVEL"
              value={createSignUpRequest.firstName}
              onChange={(e) => {
                setCreateSignUpRequest((prev) => ({
                  ...prev,
                  firstName: e.target.value
                }));
              }}
            />
            <BasicTextField
              fullWidth
              placeholder="HASANABBA"
              value={createSignUpRequest.lastName}
              onChange={(e) => {
                setCreateSignUpRequest((prev) => ({
                  ...prev,
                  lastName: e.target.value
                }));
              }}
            />
          </Row>
        </Column>
      </Row>

      <Row>
        <Column fullWidth gap="9px">
          <BasicLabel label={'Password'} required />
          <BasicTextField placeholder="" disabled />
        </Column>

        <Column fullWidth gap="9px">
          <BasicLabel label={'Password Confirm'} required />
          <BasicTextField placeholder="" disabled />
        </Column>
      </Row>
    </Column>
  );
};
